import firebase from './firebase';

export async function recalculateInvoiceTax(stockNumber) {
  const db = firebase.firestore();

  const dealSnap = await db.doc(`deals/${stockNumber}`).get();
  const deal = dealSnap.data() || {};
  const activeInvoiceId = deal.invoice;
  if (!activeInvoiceId) return null;

  const invoiceSnap = await db.collection('invoices').doc(activeInvoiceId).get();
  const invoice = invoiceSnap.data() || {};
  if (!invoice.hasTax) return null;

  const tradeIds = deal.trades || [];
  const tradeDocs = await Promise.all(tradeIds.map(id => db.doc(`trades/${id}`).get()));
  const tradeValue = tradeDocs.map(d => (d.data() || {}).trade || 0).reduce((a, c) => a + c, 0);

  const cashPrice = invoice.cashPrice || 0;
  const docFee = invoice.docFee || 0;
  const taxBase = Math.max(0, cashPrice + docFee - tradeValue);
  const salesTax = Math.round(taxBase * 0.06 * 100) / 100;
  const surtax = Math.round(100 * (taxBase * 0.01 >= 50 ? 50 : taxBase * 0.01)) / 100;
  const revenue = cashPrice + docFee + (invoice.titleFee || 0) + (invoice.tagFee || 0) + (invoice.conciergeFee || 0);
  const total = revenue + salesTax + surtax;

  await db.collection('invoices').doc(activeInvoiceId).update({ taxDeduction: tradeValue, salesTax, surtax, total });

  return tradeValue;
}
